<template>
<div class="flex w-full vx-row no-gutter justify-center">
   <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    
    <vx-card class="study-card">
      <div class="lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base text-center">
        <h1 class="mb-4 text-danger">Oops!</h1>
        <h3 class="mb-4 text-primary">학습기를 준비 중 입니다.</h3>
        <vs-button @click="onNext">다음으로 넘어가기</vs-button>
      </div>
    </vx-card>
  </div>  
  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'

export default {
  mixins: [StudyMenuMixin],
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
   
  },
  methods: {
  },
  created () {
  }
}

</script>

